/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { Divider } from 'primereact/divider';
import { Timeline } from 'primereact/timeline';


import Iframe from '@components/Iframe';

import { addDocuemntToHtmlGenerate } from '@actions/documents';

class Preview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      currentDocumentSection: '',
      isFirstRender: true
    }
    this.actions = [
      {
        label: this.props.t('Enviar a autorizar'),
        icon: 'pi pi-users',
        command: (e) => {
            this.props.authorize()
        }
      },
      {
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: (e) => {
              this.props.authorize()
          }
      }
    ]
    this.actionsEdit = [
      {
        label: this.props.t('Enviar a autorizar'),
        icon: 'pi pi-users',
        command: (e) => {
            this.props.authorize()
        }
      },
      {
        label: this.props.t('Eliminar versión'),
        icon: 'pi pi-trash',
        command: (e) => {
            this.props.deleteVersion()
        }
      },
      {
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: (e) => {
              this.props.authorize()
          }
      },
      {
        label: this.props.t('Rechazar'),
        icon: 'pi pi-times',
        command: (e) => {
          this.props.reject()
        }
      },
    ]
  }

  async componentDidMount() {
    const { addDocuemntToHtmlGenerate, itemsTabsLenguages, t } = this.props
    await addDocuemntToHtmlGenerate()
    this.setLayoutByLanguagetab(0)
  }

  onChangeTabLanguage = (index) => {
    this.setState({ step: index })
    this.setLayoutByLanguagetab(index)
  }

  setLayoutByLanguagetab = (index) => {
    const { keysLenguages, layoutsHtml } = this.props
    const { isFirstRender } = this.state
    const prefixLenguage = keysLenguages[index]
    const { html } = layoutsHtml.find(item => item.language === prefixLenguage)
    this.setState({currentDocumentSection: html})
    if ( isFirstRender ) {
      setTimeout(() => {
        this.setState({currentDocumentSection: html, isFirstRender: false})
      }, 1000);
    }
  }

  render() {
    const { t, btnSubmitLoading, onBack, success, isEdit, itemsStep } = this.props;
    const { currentDocumentSection, step } = this.state

    const customizedMarker = ( index) => {
      if (index === step) return (<i className="pi pi-circle-on cursor-pointer" onClick={() => this.onChangeTabLanguage(index)} style={{ color: "#ffe357", fontSize: "1.4rem" }}/>)
      return (<i className="pi pi-circle-off cursor-pointer" onClick={() => this.onChangeTabLanguage(index)} style={{ color: "#bdc2ce", fontSize: "1.4rem" }}/>)
    };

    const contentTimeline = (item, index) => (<p className="cursor-pointer" onClick={() => this.onChangeTabLanguage(index)}>{item.label}</p>)

    return (
      <>
        <div className="p-grid p-justify-end">
          <div className="p-col-12 p-md-9 p-lg-9 footer-btn p-mb-4">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => success()} model={isEdit ? this.actionsEdit : this.actions}/>
            </div>
          </div>
        </div>
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-12 p-md-3 p-lg-3">
            <Timeline value={itemsStep} align="right" marker={(item, index) => customizedMarker(index)} content={(item, index) => contentTimeline(item, index)} />
          </div>
          <Divider layout="vertical" />
          <div className="p-col content-iframe">
            { currentDocumentSection && <Iframe content={currentDocumentSection.outerHTML} />}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  layoutsHtml: state.document.layoutsHtml,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  itemsStep: state.catalogs.itemsLanguageCatalog
});

const mapDispatchToProps = {
  addDocuemntToHtmlGenerate
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Preview);

